export const homeObjOne = {
  lightBg: false,
  imgStart: "start",
  lightTopline: true,
  lightTextDesc: true,
  buttonLabel: "Get Started",
  description:
    "The main goal is to support our economy, tourism, and hospitality industry. Additionally, the platform offers its members necessary assistance through collaboration with experts in key fields for business success, such as further technology development, recipes, design, and access to additional production financing.",
  headline: "Our Goals",
  lightText: true,
  topLine: "SerBeat Online",
  primary: true,
  img: require("../../images/svg-1.svg").default,
  alt: "Image",
  start: "true",
};

export const homeObjThree = {
  lightBg: false,
  imgStart: "",
  lightTopline: true,
  lightTextDesc: true,
  buttonLabel: "Get Started",
  description:
    "We help our clients increase their revenue. Our team of unique specialist can help you achive your business goals",
  headline: "Lead Generetaion Specialist for Online Businesses",
  lightText: true,
  topLine: "Marketing Agency",
  primary: true,
  img: require("../../images/svg-2.svg").default,
  alt: "Image",
  start: "",
};

export const homeObjFour = {
  lightBg: true,
  imgStart: "",
  lightTopline: false,
  lightTextDesc: false,
  buttonLabel: "Get Started",
  description:
    "The platform is based on organising events and participating in external events, sales, import and export, and connecting with the hospitality and tourism sectors. It also facilitates the creation of a network of franchise and standardized concept stores and markets, as well as member clubs for mutual connections and target market engagement. ",
  headline: "We Organise Events",
  lightText: false,
  topLine: "SerBeat Online",
  primary: true,
  img: require("../../images/Simg02.jpg"),
  alt: "Image",
  start: "true",
};
